import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 90 90",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<rect width="90" height="90" fill="#C1D0CB" rx="20"/> <path fill="#1A3446" d="M53.997 29.11c-.007-.006-.01-.012-.013-.016l-2.765-2.758c-2.069-2.074-5.123-2.852-7.933-2.328-.197.035-.384.113-.577.164-.355.087-.709.164-1.047.296a8.258 8.258 0 0 0-2.871 1.855l-2.781 2.775a.068.068 0 0 0-.013.016L16.64 48.424a8.63 8.63 0 0 0-2.577 6.174 8.682 8.682 0 0 0 2.548 6.209l2.797 2.784a8.727 8.727 0 0 0 6.207 2.56c2.349 0 4.55-.907 6.203-2.56L45 50.437l13.199 13.167a8.718 8.718 0 0 0 6.19 2.543 8.7 8.7 0 0 0 6.203-2.56l2.78-2.774.017-.013a8.66 8.66 0 0 0 2.548-6.15 8.644 8.644 0 0 0-2.565-6.219l-19.375-19.32Z"/>' }
  })
);